import {Component, OnInit, Input} from "@angular/core";
import {Job} from "../../job/shared/job.model";
import {JobPage} from "../../job/job.page";
import {App, NavController} from "ionic-angular";
import {AppAuth} from "../../../app/core/auth";


@Component({
  selector: 'app-jobs-list',
  templateUrl: 'jobs-list.component.html'
})
export class JobsListComponent implements OnInit {
  @Input() jobs: Job[];
  private nav: NavController;

  constructor(private app: App, private auth: AppAuth) {
    this.nav = this.app.getRootNav();
  }

  ngOnInit(): any {
  }

  goToJob(job) {
    this.nav.push(JobPage, {id: job.id});
  }

  isCurrentUserPreferred(job){
    return this.auth.user && job.preferred_interpreter_id === this.auth.user.sub;
  }
}



// WEBPACK FOOTER //
// ./src/pages/jobs-list/shared/jobs-list.component.ts